import tinycolor from "tinycolor2";
import { useColorComponent } from "../useColorComponent";
import { ColorComponentContainer } from "../ColorComponentContainer";
import { ColorComponentType } from "store/features/colorPicker/types";

export interface HSLProps {
    hex: string;
}

export const HSL = ({ hex }: HSLProps) => {
    const { color, components, handleChange } = useColorComponent(tinycolor(hex).toHsl(), "hsl");
    return (
        <>
            {(Object.keys(components) as Array<keyof typeof components>).map((key) => {
                const component = components[key];
                return (
                    <ColorComponentContainer
                        componentKey={key}
                        type={component.type}
                        value={component.type === ColorComponentType.PERCENTAGE ? color[key] * 100 : color[key]}
                        max={component.max}
                        handleChange={handleChange}
                    />
                );
            })}
        </>
    );
};
